import { render, staticRenderFns } from "./Template23.vue?vue&type=template&id=0ef117dc&scoped=true&"
import script from "./Template23.vue?vue&type=script&lang=js&"
export * from "./Template23.vue?vue&type=script&lang=js&"
import style0 from "./Template23.vue?vue&type=style&index=0&id=0ef117dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef117dc",
  null
  
)

export default component.exports